/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertMemoriesAppRequest} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'
import {UpsertMemoriesAppResponse} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'


export const upsertMemoriesApp = (request: UpsertMemoriesAppRequest, options?: CashRequestOptions) => post<UpsertMemoriesAppRequest, UpsertMemoriesAppResponse>("/2.0/cash/upsert-memories-app", request, {...options, rejectOnError: true })